import React from 'react';
import {
    Text,
    AlphaCard,
    Button,
} from '@shopify/polaris';

function BulkOperationCard(props) {

    const {title, description, imageSrc, onCreate} = props;

    return (<AlphaCard>
        <div>
            <Text variant="headingMd" as="h3" alignment="center">{title}</Text>
            <br />
        </div>
        <div>
            <img alt="operation" className='operationCardImage' src={imageSrc} />
        </div>
        <Text variant="bodyLg" as="p" alignment="center">{description}</Text>
        <br />
        <Button fullWidth primary onClick={onCreate}>Create</Button>
    </AlphaCard>
    );
}

export default BulkOperationCard;